import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import Filter from "./desktop/filter"
import Resort from './desktop/resort'
import RefundRequestButton from "../RefundRequestButton"


export default function DesktopComponent() {


    const [desktopItems, setDesktopItems] = useState()


    let filteredOrders = useSelector((state) => state.order.filteredOrders)

    let stateorders = useSelector(state => state.order.orders)


    useEffect(() => {

        let items = []
        let orders = filteredOrders ?? stateorders

        if (orders && Object.keys(orders).length > 0) {

            orders.forEach((order) => {

                items.push(<DesktopItem key={order.id} order={order} />)

            })
        }
        setDesktopItems(items)



    }, [filteredOrders, stateorders])


    if (!desktopItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <table className="table table-striped table-bordered" >
                <thead>
                    <tr>

                        <th>OrderId <Resort type='order_id' /></th>
                        <th>ProductTitle <Resort type='ptitle' /></th>
                        <th>Token <Resort type='token' /></th>
                        <th>Active <Resort type='active' /></th>
                        <th>Start <Resort type='start' /></th>
                        <th>End <Resort type='end' /></th>
                        <th>Refund</th>
                    </tr>
                </thead>
                <tbody>
                    {desktopItems}
                </tbody>
            </table>
        </Filter>
        <Backdrop />

    </Fragment>
}


function DesktopItem(props) {
    const { order } = props
    const status = order.expired ? 'Expired' : (order.active ? 'Active' : 'Inactive')
    const statusClass = order.expired ? 'bg-danger' : (order.active ? 'bg-success' : 'bg-secondary')
   
    return <Fragment>

        <tr>

            <td>
                {order.order_id}
            </td>
            <td>
            <Link to={`/products/${order.product_id}`} state={{
                product:null
            }} >{order.ptitle}</Link>
                
            </td>
            <td>
                {order.token}
            </td>
            <td>
                <span className={`badge ${statusClass}`}>{status}</span>
            </td>
            <td>
                {order.start}
            </td>
            <td>
                {order.end}
            </td>
            <td>
                <RefundRequestButton order={order} />
            </td>
           
        </tr>

    </Fragment>

}
